export default "__VITE_ASSET__553245e0__"